import Link from "next/link";
import { useRouter } from "next/router";
import clsx from "clsx";
import {
  FaHome,
  FaNewspaper,
  FaEnvelope,
  FaEllipsisH,
} from "react-icons/fa";
import useNavReloadOnActive from "./useNavReloadOnActive";

const isCurrent = (router, href) => {
  if (!href) return false;
  if (href === "/") return router.pathname === "/";
  return router.pathname === href || router.pathname.startsWith(`${href}/`);
};

const tabs = [
  { key: "home", label: "Home", href: "/", Icon: FaHome },
  { key: "blog", label: "Blog", href: "/blog", Icon: FaNewspaper },
  { key: "contact", label: "Contact", href: "/contact", Icon: FaEnvelope },
  {
    key: "more",
    label: "More",
    Icon: FaEllipsisH,
    opensDrawer: true,
  },
];

const BottomTabBar = ({ onMore }) => {
  const router = useRouter();
  const onActiveClick = useNavReloadOnActive();
  return (
    <nav className="site-bottom-tabs" aria-label="Quick navigation">
      {tabs.map(({ key, label, href, Icon, opensDrawer }) => {
        const current = !opensDrawer && isCurrent(router, href);
        const className = clsx(
          "site-bottom-tabs__item",
          current && "is-current"
        );

        if (opensDrawer) {
          return (
            <button
              key={key}
              type="button"
              className={className}
              onClick={onMore}
              aria-label="Open more navigation"
            >
              <Icon aria-hidden />
              <span>{label}</span>
            </button>
          );
        }

        return (
          <Link
            key={key}
            href={href}
            className={className}
            aria-current={current ? "page" : undefined}
            onClick={(e) => {
              // Re-tap on the active bottom tab → soft-reload the page.
              if (current) onActiveClick(e, href);
            }}
          >
            <Icon aria-hidden />
            <span>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomTabBar;